(() => {
  if (window.customProductStyleNumberGapV1) return;
  window.customProductStyleNumberGapV1 = true;
  const states = new WeakMap();
  const prefix = 'custom-style-number-gap-v1';
  const text = (node) => (node.textContent || '').replace(/\s+/g, ' ').trim();
  const code = /^(?:Style\s*(?:No\.?|Number|#)?\s*[:#]?\s*)?#?\s*AS[A-Z]{0,6}(?:[ -][A-Z]{0,6})?[ -]?\d[A-Z0-9-]*\s*$/i;
  function rect(node, last = false) {
    const range = document.createRange();
    range.selectNodeContents(node);
    const boxes = [...range.getClientRects()].filter((box) => box.width && box.height);
    return last ? boxes.at(-1) : boxes[0];
  }
  function adjust(state) {
    state.line.style.setProperty('--custom-style-number-gap-offset', '0px');
    const left = rect(state.notice, true);
    const right = rect(state.line);
    if (!left || !right) return;
    const typography = getComputedStyle(state.notice.parentElement);
    const lineHeight = Number.parseFloat(typography.lineHeight) || Number.parseFloat(typography.fontSize) * 1.2;
    // Two line advances leave exactly one empty line before the internal style.
    state.line.style.setProperty('--custom-style-number-gap-offset', `${2 * lineHeight - (right.top - left.top)}px`);
  }
  function apply(root) {
    // Preserve merchant-authored one-blank-line descriptions without ratio compaction.
    if (root.querySelector('.custom-style-number-single-blank-line-v1')) return;
    if (states.has(root)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) if (text(walker.currentNode)) nodes.push(walker.currentNode);
    const index = nodes.findIndex((node, i) => /colou?rs?\b/i.test(text(node))
      && /colou?rs?\s*may\s+vary/i.test(nodes.slice(i, i + 5).map(text).join(' ')));
    let styleIndex = nodes.findIndex((node, i) => i > index && code.test(text(node)));
    let holder;
    if (styleIndex < 0) {
      holder = [...root.querySelectorAll('p, div, span, strong, b')].find((element) =>
        code.test(text(element))
        && ![...element.children].some((child) => code.test(text(child)))
        && nodes.findIndex((node) => element.contains(node)) > index
      );
      if (!holder) return;
      styleIndex = nodes.findIndex((node) => holder.contains(node));
    }
    if (styleIndex <= 0) return;
    const fullBoundary = document.createRange();
    fullBoundary.setStartAfter(nodes[index >= 0 ? index : styleIndex - 1]);
    fullBoundary.setEndBefore(nodes[styleIndex]);
    const fullContent = fullBoundary.cloneContents();
    if (fullContent.querySelector('img, picture, video, iframe, table, details')
      || /more\s+colou?rs?\s+avail/i.test(text(fullContent))) return;
    // Some descriptions retain other feature lines after the color notice.
    // Compact only the trailing blank gap, preserving those lines unchanged.
    const notice = nodes[styleIndex - 1];
    const style = nodes[styleIndex];
    if (notice.parentElement.closest('table, details') || style.parentElement.closest('table, details')) return;
    const boundary = document.createRange();
    boundary.setStartAfter(notice);
    boundary.setEndBefore(style);
    const content = boundary.cloneContents();
    if (text(content) || content.querySelector('img, picture, video, iframe, table, details, input, button')) return;
    const left = rect(notice, true);
    const right = rect(style);
    if (!left || !right || right.top < left.bottom) return;
    const originalGap = right.top - left.bottom;
    const common = boundary.commonAncestorContainer.nodeType === Node.ELEMENT_NODE
      ? boundary.commonAncestorContainer : boundary.commonAncestorContainer.parentElement;
    // Hide only empty markup strictly between the two retained text nodes.
    root.querySelectorAll('*').forEach((element) => {
      if (element.contains(notice) || element.contains(style) || text(element) || !boundary.intersectsNode(element)) return;
      element.classList.add(`${prefix}--empty`);
    });
    for (let element = notice.parentElement; element && element !== common && element !== root; element = element.parentElement) element.classList.add(`${prefix}--after`);
    for (let element = style.parentElement; element && element !== common && element !== root; element = element.parentElement) element.classList.add(`${prefix}--before`);
    const line = document.createElement('span');
    line.className = prefix;
    if (holder) {
      const children = [...holder.childNodes];
      holder.append(line);
      children.forEach((child) => line.append(child));
    } else {
      style.before(line);
      line.append(style);
    }
    const state = { notice, line, originalGap };
    states.set(root, state);
    adjust(state);
    root.dataset.customStyleNumberGap = 'ready';
  }
  const refresh = () => document.querySelectorAll('.product__description').forEach(apply);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
  document.fonts?.ready.then(() => {
    refresh();
    document.querySelectorAll('.product__description').forEach((root) => { const state = states.get(root); if (state) adjust(state); });
  });
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('american-stride:description-spacing', refresh);
  let timer;
  window.addEventListener('resize', () => {
    clearTimeout(timer);
    timer = setTimeout(() => document.querySelectorAll('.product__description').forEach((root) => { const state = states.get(root); if (state) adjust(state); }), 120);
  }, { passive: true });
})();
